import { Injectable } from '@angular/core';
import { createStore, select, withProps } from '@ngneat/elf';
import { localStorageStrategy, persistState } from '@ngneat/elf-persist-state';

interface AuthProps {
  loginRedirectUrl: string;
  isLoggedIn: boolean;
}

const store = createStore(
  { name: 'auth' },
  withProps<AuthProps>({
    // @ts-expect-error foo
    loginRedirectUrl: null,
    isLoggedIn: false
  })
);

export const persist = persistState(store, {
  key: 'auth',
  storage: localStorageStrategy
});

@Injectable({
  providedIn: 'root'
})
export class AuthRepository {
  isLoggedIn$ = store.pipe(select((state) => state.isLoggedIn));

  get loginRedirectUrl(): string {
    return store.getValue().loginRedirectUrl;
  }

  setLoginRedirectUrl(loginRedirectUrl: string) {
    store.update((state) => ({
      ...state,
      loginRedirectUrl
    }));
  }

  setIsLoggedIn(isLoggedIn: boolean) {
    store.update((state) => ({
      ...state,
      isLoggedIn
    }));
  }

  reset() {
    store.reset();
  }

  clearPersist() {
    persist.unsubscribe();
  }
}
